module.exports = __webpack_public_path__ + "img/sun.e076b57b.svg";